(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('jquery'), require('./unified-password.jsx'));

    } else {
        root.unity = factory(root.jQuery, root.unifiedPassword);
    }
}(this, function ($, unifiedPassword) {
    'use strict';

    var unified = {};

    unified.init = function () {
        var setupScrollbar = function () {
                //Scrollbar
                $('.dashboard_mainContent').mCustomScrollbar({
                    theme: 'dark',
                    scrollInertia: 100,
                    autoHideScrollbar: true,
                    axis: 'y',
                    scrollbarPosition: 'inside'
                });
            },
            setupDashboard = function () {
                $('.dashboard_owned .dashboard_toggleProducts').on('click', function () {
                    $('.dashboard_other').show();
                    $('.dashboard_owned').slideUp(400);
                });

                $('.dashboard_other .dashboard_toggleProducts, .dashboard_subHeader_close').on('click', function () {
                    $('.dashboard_owned').slideDown(400, function () {
                        $('.dashboard_other').hide();
                    });
                });

                $('.dashboard_productButton_list').on('click', '.dashboard_productButton_listActivate', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    $(this).siblings('.dashboard_productButton_listProducts').toggleClass('active');
                })
                    .on('click', '.dashboard_productButton_listProduct', function (e) {
                        e.stopPropagation();
                        e.preventDefault();

                        document.location = this.getAttribute('data-action');
                    });
            },
            setup = function () {
                setupDashboard();
                unifiedPassword.setupReset();
            };

        $(setup);
    };

    return unified;
}));
